import gql from 'graphql-tag'

export const DUPLICATE_PROJECT = gql`
  mutation DuplicateProject($projectUuid: ID!, $projectName: String, $projectLevel: ProjectLevel) {
    duplicateProject(
      projectUuid: $projectUuid
      projectName: $projectName
      projectLevel: $projectLevel
    ) {
      uuid
      projectLevel
    }
  }
`



// WEBPACK FOOTER //
// ./src/mutations/DuplicateProject.tsx